'use client';

import { useEffect } from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { IFlightsEnrichmentData } from '../../../flights/shared/flight/domain/models/IEnrichedFlight';
import { useSetFlightsEnrichmentData } from '../../../flights/shared/flight/ui/useSetFlightsEnrichmentData';
import { useFlightStores } from '../../../flights/shared/context/flightStoresContext';
import {
	FlightSearch,
	StyledFlightSearchForm,
} from '../../../flights/search/ui/FlightSearch';
import { Css, ITheme, Responsive } from '../../../../ui';
import BookParkingIcon from '../../../../assets/icons/book-parking.svg';
import { Z_INDEX_BASE } from '../../../../styles/zIndex';
import { BOOK_PARKING_URL } from '../FeatureEntryPointsSection';
import LinkButton from '../../../../components/common/button/LinkButton';

interface IProps {
	flightsEnrichmentData: IFlightsEnrichmentData;
}

export const FlightSearchWidget = observer(
	({ flightsEnrichmentData }: IProps) => {
		const { flightListStore } = useFlightStores();
		useSetFlightsEnrichmentData(flightsEnrichmentData);
		useEffect(() => {
			flightListStore.initialLoad();
		}, []);

		return (
			<Wrapper>
				<FlightSearch submitOnClear={false} />
				<StyledButton
					href={BOOK_PARKING_URL}
					target="_blank"
					iconPosition="left"
					icon={<BookParkingIcon aria-hidden />}
					aria-label="Open new tab to book parking"
				>
					Reserve Parking
				</StyledButton>
			</Wrapper>
		);
	},
);

const Wrapper = styled.div`
	display: flex;
	gap: ${Css.pxToRem(16)};
	${StyledFlightSearchForm} {
		width: auto;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column;
	}
`;

const StyledButton = styled(LinkButton)<{}, ITheme>`
	width: ${Css.pxToRem(240)};
	height: auto;

	z-index: ${Z_INDEX_BASE};
	display: flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;
	padding: ${Css.pxToRem(16)};

	color: ${({ theme }) => theme.button.primary.font.color};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
	}
`;
